/**
 * The platform-wide `User.role` field ("users"/"admins", gates superadmin
 * routes like /users, /organizations — see MainRoutesComponent.js's
 * `isAdmin` check). Not to be confused with `UserRoles` in ./crm.js, which
 * is the per-workspace membership role (owner/admin/member).
 */
export const AppUserRole = {
  user: "users",
  admin: "admins",
};

export const AppUserRoleLabels = {
  [AppUserRole.user]: "User",
  [AppUserRole.admin]: "Admin",
};

export const AppUserRoleOptions = [
  { value: AppUserRole.user, label: AppUserRoleLabels[AppUserRole.user] },
  { value: AppUserRole.admin, label: AppUserRoleLabels[AppUserRole.admin] },
];
